var o = typeof window < "u" ? window : {};
export {
  o as global
};
